import Vue from "vue";
import VueRouter from "vue-router";

import client from '@/views/client'

//解决多次跳转同一路由出现bug
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter);

const routes = [
    {
        path: "/index/:deviceNo"
    },
    {
        path:'/video',
        name: 'video',
        component: () =>
            import ("@/views/videoplayer.vue"),
            meta: {
                title:'视频播放器'
            }
    },
    {
        path: "/boaccount",
        name: "client",
        component: client,
        children: [{
                path: 'client/main',
                name: 'clientMain',
                component: () =>
                    import ("@/views/client/main.vue"),
                children: [
                    {
                        path: 'warnPage/:warnMsg',
                        name: 'warnPage',
                        component: () =>
                            import ("@/views/client/warnPage.vue")
                    },
                    {
                        path: 'login',
                        name: 'login',
                        component: () =>
                            import ("@/views/client/login.vue")
                    },
                    {
                        path: 'faceLogin',
                        name: 'faceLogin',
                        component: () =>
                            import ("@/views/client/faceLogin.vue")
                    },
                    {
                        path: 'faceGather',
                        name: 'faceGather',
                        component: () =>
                            import ("@/views/client/faceGather.vue")
                    },
                    {
                        path: 'start',
                        name: 'start',
                        component: () =>
                            import ("@/views/client/startMake.vue")
                    },
                    {
                        path: 'waitScan',
                        name: 'waitScan',
                        component: () =>
                            import ("@/views/client/waitScan.vue")
                    },
                    {
                        path: 'editImage',
                        name: 'editImage',
                        component: () =>
                            import ("@/views/client/editImage.vue")
                    },
                    {
                        path: 'infoAnalysis',
                        name: 'infoAnalysis',
                        component: () =>
                            import ("@/views/client/infoAnalysis.vue")
                    },
                    {
                        path: 'fileWaitScan',
                        name: 'fileWaitScan',
                        component: () =>
                            import ("@/views/client/fileScan/fileWaitScan.vue")
                    },
                    {
                        path: 'fileEditImage',
                        name: 'fileEditImage',
                        component: () =>
                            import ("@/views/client/fileScan/fileEditImage.vue")
                    },
                    {
                        path: 'finishFileScan',
                        name: 'finishFileScan',
                        component: () =>
                            import ("@/views/client/fileScan/finishFileScan.vue")
                    },
                    {
                        path: 'orderInfo',
                        name: 'orderInfo',
                        component: () =>
                            import ("@/views/client/orderInfo.vue")
                    },
                    {
                        path: 'printVouche',
                        name: 'printVouche',
                        component: () =>
                            import ("@/views/client/printVouche.vue")
                    },
                    {
                        path: 'accountVoucher',
                        name: 'accountVoucher',
                        component: () =>
                            import ("@/views/client/accountVoucher.vue")
                    },
                    {
                        path: 'test',
                        name: 'test',
                        component: () =>
                            import ("@/views/client/testImage.vue")
                    },{
                        path: 'netErrPage',
                        name: 'netErrPage',
                        component: () =>
                            import ("@/views/client/netErrPage.vue")
                    }
                ]
            },
            {
                path: 'manager/main',
                name: 'managerMain',
                component: () =>
                    import ("@/views/manager/main.vue"),
                children: [{
                        path: 'home',
                        name: 'home',
                        component: () =>
                            import ("@/views/manager/home.vue")
                    },
                    {
                        path: 'inputName',
                        name: 'inputName',
                        component: () =>
                            import ("@/views/manager/inputName.vue")
                    },
                    {
                        path: 'inputPassword',
                        name: 'inputPassword',
                        component: () =>
                            import ("@/views/manager/inputPassword.vue")
                    },
                    {
                        path: 'customForm',
                        name: 'customForm',
                        component: () =>
                            import ("@/views/manager/customForm.vue")
                    }
                ]
            },
            {
                path: 'errorPage',
                name: 'errorPage',
                component: () =>
                    import ("@/views/errorPage.vue")
            },
            {
                path: 'servicePage',
                name: 'servicePage',
                component: () =>
                    import ("@/views/servicePage.vue")
            }
        ]
    }
];

const router = new VueRouter({
    //mode: 'history',
    routes
    //base: '/client/'
});

// router.beforeEach(async (to) => {
//     if(to.meta.title){
//         document.title = to.meta.title
//     }
// })

export default router;